export enum SERVER_ERRORS {
  INVALID_TOKEN = 'Invalid token',
  THERE_MUST_BE_ONE_ADMIN = 'There must be at least one admin user',
}
